import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as auth from "../../_redux/authRedux";
import { verifyTwoFactor, resendTwoFactorCode } from "../../_redux/authCrud";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

const CODE_LENGTH = 6;

const GENERIC_ERROR = "Ocorreu um erro, por favor, tente novamente.";

function resolveErrorMessage(err) {
  return err?.response?.data?.message || GENERIC_ERROR;
}

function TwoFactor(props) {
  const history = useHistory();
  const location = useLocation();

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [retryAt, setRetryAt] = useState(null);
  const [secondsToRetry, setSecondsToRetry] = useState(0);

  const state = location.state || {};
  const { email, tempToken } = state;

  useEffect(() => {
    if (!tempToken) {
      history.replace("/auth/login");
    }
  }, [tempToken, history]);

  useEffect(() => {
    if (!retryAt) {
      setSecondsToRetry(0);
      return undefined;
    }

    const tick = () => {
      const remaining = Math.ceil((retryAt.getTime() - Date.now()) / 1000);

      if (remaining > 0) {
        setSecondsToRetry(remaining);
      } else {
        setSecondsToRetry(0);
        setRetryAt(null);
      }
    };

    tick();
    const timer = setInterval(tick, 1000);

    return () => clearInterval(timer);
  }, [retryAt]);

  const handleCodeChange = evt => {
    const digitsOnly = evt.target.value.replace(/\D/g, "");
    setCode(digitsOnly.slice(0, CODE_LENGTH));
    setError("");
    setSuccessMessage("");
  };

  const handleSubmit = () => {
    if (loading) {
      return;
    }

    if (code.length !== CODE_LENGTH) {
      setError("Digite os 6 dígitos do código enviado para o seu e-mail.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccessMessage("");

    verifyTwoFactor(code, tempToken)
      .then(({ data }) => {
        const token = data?.data?.token;

        if (!token) {
          setLoading(false);
          setError(GENERIC_ERROR);
          return;
        }

        props.login(token);
      })
      .catch(err => {
        setLoading(false);
        setCode("");
        setError(resolveErrorMessage(err));
      });
  };

  const handleResend = () => {
    setResending(true);
    setError("");
    setSuccessMessage("");

    resendTwoFactorCode(tempToken)
      .then(() => {
        setResending(false);
        setCode("");
        setSuccessMessage("Um novo código foi enviado para o seu e-mail.");
      })
      .catch(err => {
        setResending(false);

        const nextRetryAt = err?.response?.data?.data?.retryAt;

        if (err?.response?.status === 429 && nextRetryAt) {
          setRetryAt(new Date(nextRetryAt));
        }

        setError(resolveErrorMessage(err));
      });
  };

  const handleKeyDown = evt => {
    if (evt.key === "Enter") {
      handleSubmit();
    }
  };

  const handleBackToLogin = () => {
    history.replace("/auth/login");
  };

  if (!tempToken) {
    return null;
  }

  const isResendDisabled = resending || secondsToRetry > 0;

  return (
    <div
      className="jusfy-login"
      style={{
        background: `url(${toAbsoluteUrl(
          "/media/bg/bg-login.png"
        )}) no-repeat center center fixed`
      }}
    >
      <div className="head-login">
        <div className="container">
          <div className="logo">
            <img src={toAbsoluteUrl("/media/logos/logo-light.svg")} alt="Jusfy" />
          </div>
        </div>
      </div>
      <div className="content-login">
        <div className="container">
          <div className="row" style={{ marginTop: "150px" }}>
            <div className="col-xl-5">
              <h1 className="titulo" style={{ color: "#fff", fontSize: "34px" }}>
                Verificação em duas etapas
              </h1>
              <p
                className="subtitle"
                style={{
                  marginTop: "30px",
                  fontWeight: "500",
                  opacity: "0.8",
                  letterSpacing: "-0.01em",
                  color: "#fff",
                  fontSize: "18px"
                }}
              >
                O acesso ao backoffice exige a confirmação de um código a cada
                login.
              </p>
            </div>
            <div className="col-xl-3"> </div>
            <div className="col-xl-4">
              <h1
                className="mb-10 login-entrar"
                style={{
                  fontSize: "29px",
                  color: "#091740",
                  letterSpacing: "-0.04em"
                }}
              >
                Confirme seu código
              </h1>
              <div
                className="box-login"
                style={{
                  border: "1px solid #eaeaea",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "100%"
                }}
              >
                {error && (
                  <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                    <div className="alert-text font-weight-bold">{error}</div>
                  </div>
                )}
                {successMessage && (
                  <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
                    <div className="alert-text font-weight-bold">
                      {successMessage}
                    </div>
                  </div>
                )}
                <p className="label-login">
                  Enviamos um código de 6 dígitos para{" "}
                  <strong>{email || "o seu e-mail"}</strong>.
                </p>
                <input
                  aria-label="Código de verificação de seis dígitos"
                  autoFocus
                  value={code}
                  type="text"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  maxLength={CODE_LENGTH}
                  className="form-control"
                  style={{
                    marginBottom: "30px",
                    letterSpacing: "10px",
                    fontSize: "24px",
                    textAlign: "center"
                  }}
                  onChange={handleCodeChange}
                  onKeyDown={handleKeyDown}
                  name="code"
                />

                <div className="row">
                  <div className="col-xl-6">
                    <button
                      style={{ width: "100%" }}
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading || code.length !== CODE_LENGTH}
                    >
                      {loading && (
                        <span className="ml-3 spinner spinner-white"></span>
                      )}
                      CONFIRMAR
                    </button>
                  </div>
                  <div className="col-xl-6">
                    <button
                      style={{ width: "100%" }}
                      className="btn btn-light"
                      onClick={handleResend}
                      disabled={isResendDisabled}
                    >
                      {secondsToRetry > 0
                        ? `AGUARDE ${secondsToRetry}s`
                        : "REENVIAR CÓDIGO"}
                    </button>
                  </div>
                </div>

                <div className="mt-5">
                  <button
                    className="btn btn-link p-0"
                    onClick={handleBackToLogin}
                  >
                    Voltar para o login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, auth.actions)(TwoFactor);
